export default __webpack_public_path__ + "static/media/0261.cfe46429.jpg";